import * as React from "react";
import {Box, Grid, SxProps, Theme} from "@mui/material";

interface IButtonsContainerProps {
    gridProps?: any;
    children: React.ReactNode;
}

export const ButtonsContainer = ({gridProps = {}, children}: IButtonsContainerProps) => {
    return (
        <Grid size={{ xs: 12 }} {...gridProps}>
            {children}
        </Grid>
    );
};

interface IButtonsProps {
    position?: "beforeSubmit" | "afterSubmit";
    sx?: SxProps<Theme>;
    children: React.ReactNode;
}

export const Buttons = ({position, sx, children}: IButtonsProps) => {
    return (
        <Box sx={{display: 'inline-block', ...(position === 'beforeSubmit' ? {marginRight: 2} : {marginLeft: 2}), ...sx}}>
            {children}
        </Box>
    );
};
